
export const content = {
  da: {
    company: "Vejrumbro Smede Maskinforretning ApS",
    address: "Hovedgaden 4, 8830 Tjele",
    phone: "+45 21 59 00 19",
    email: "kra@vejrumbromaskinforretning.dk",
    cvr: "46156765",
    nav: [
      { name: "Forside", path: "/" },
      { name: "Udekørende service", path: "/udekoerende-service" },
      { name: "Smede & maskinforretning", path: "/smede-og-maskinforretning" },
      { name: "Kran & lift", path: "/kran-og-lift" },
      { name: "Reservedele", path: "/reservedele" },
      { name: "Om os", path: "/om-os" },
      { name: "Kontakt", path: "/kontakt" },
    ],
    ui: {
      readMore: "Læs mere",
      callNow: "Ring nu",
      sendMail: "Send mail",
      ourServices: "Vores Services",
      servicesSubtitle: "Vi tilbyder professionelle løsninger inden for smede- og maskinarbejde med fokus på kvalitet og fleksibilitet.",
      focusArea: "Fokusområde",
      owner: "Direktør",
      aboutUs: "Om os",
      solidPartner: "En solid partner i hele landet",
      aboutText: "Vi betjener både private, erhverv og landbrug med alt fra små reparationer til større maskinservice og smedearbejde. Vores fokus er altid på at levere en løsning, der virker i virkeligheden.",
      quality: "Kvalitet",
      personal: "Personlig",
      flexible: "Fleksibel",
      local: "Landsdækkende",
      findUs: "Find os her",
      addressLabel: "Adresse",
      phoneLabel: "Telefon",
      contactMessage: "Vi glæder os til at høre fra dig.",
      sendMessage: "Send en besked",
      nameLabel: "Navn",
      namePlaceholder: "Dit fulde navn",
      contactLabel: "Email / Telefon",
      contactPlaceholder: "Hvordan kontakter vi dig?",
      messageLabel: "Besked",
      messagePlaceholder: "Beskriv din opgave...",
      submitButton: "Send besked",
      successMessage: "Tak for din besked!",
      ctaTitle: "Skal vi hjælpe dig med din næste opgave?",
      weOffer: "Vi tilbyder blandt andet:",
      needAssistance: "Brug for assistance?",
      contactToday: "Kontakt os i dag for en uforpligtende snak om dit projekt eller din opgave.",
      nationwide: "Udekørende service over hele landet",
      nationwideText: "Vi kommer gerne ud til dig og hjælper med din maskine eller dit smedearbejde, uanset hvor du befinder dig.",
      copyright: "Alle rettigheder forbeholdes."
    },
    hero: {
      title: "Udekørende service inden for smede- og maskinopgaver",
      subtitle: "Vejrumbro Smede Maskinforretning ApS hjælper private, erhverv og landbrug med smedearbejde, maskinservice, kran/lift og reservedele — både på værkstedet og ude hos kunden.",
      cta_call: "Ring",
      cta_email: "Skriv",
    },
    sections: {
      onSite: {
        title: "Udekørende service",
        description: "Hurtig hjælp ude hos kunden. Vi kører ud til erhverv, landbrug og private.",
        features: [
          "Reparation og service af landbrugsmaskiner",
          "Reparation og service af entreprenørmaskiner",
          "Reparation og service af have- og parkmaskiner",
          "Fremstilling af hydraulikslanger på stedet",
          "Mobil A/C Service & diagnoseudlæsning",
          "Hurtig og fleksibel udrykning"
        ],
        image: "/images/mobile_repair_image.png"
      },
      metalwork: {
        title: "Smede & maskinforretning",
        description: "Professionelt smedearbejde og maskinservice udført med fokus på kvalitet og holdbare løsninger.",
        features: [
          "Professionelt smedearbejde",
          "Reparation og service af landbrugsmaskiner",
          "Reparation og service af entreprenørmaskiner",
          "Reparation og service af have- og parkmaskiner",
          "Fremstilling af hydraulikslanger",
          "A/C Service & diagnoseudlæsning"
        ],
        image: "/images/shutterstock_1661945515.jpg"
      },
      crane: {
        title: "Kran & lift",
        description: "Service og vedligehold af kraner og lifte. Vi sikrer, at dit udstyr er sikkert og driftsklart.",
        features: [
          "Lovpligtigt eftersyn af lifte",
          "Lovpligtigt eftersyn af lastbilkraner",
          "Lovpligtigt eftersyn af gaffeltrucks",
          "Service og vedligehold af kraner og lifte",
          "Fejlfinding og reparation"
        ],
        image: "/images/crane-equipment-only.jpg"
      },
      parts: {
        title: "Salg af reservedele",
        description: "Vi skaffer de rigtige dele til dine maskiner og tekniske løsninger.",
        features: [
          "Salg af reservedele",
          "Hjælp til at finde den rigtige del",
          "Dele til maskiner og udstyr",
          "Hurtig levering/afhentning"
        ],
        image: "/images/spare-parts.jpg"
      },
      about: {
        title: "Landsdækkende og personlig service",
        description: "Vejrumbro Smede Maskinforretning ApS er din landsdækkende partner.",
        content: "Vi er en praktisk og løsningsorienteret virksomhed, der vægter den personlige kontakt højt. Med mange års erfaring og en fleksibel tilgang finder vi altid en løsning, der holder.",
        image: "/images/kundes img/Karsten-258x300.jpg",
        certificate: {
          title: "ECM Certificering – Rail & Maskinteknik ApS",
          text1: "Rail & Maskinteknik ApS er certificeret som Entity in Charge of Maintenance (ECM) i overensstemmelse med EU-forordning 2019/779. Dette certifikat er din garanti for, at vi lever op til de strengeste europæiske standarder og sikkerhedskrav inden for vedligeholdelse af jernbanekøretøjer og dertilhørende materiel.",
          text2: "Som en betroet partner sikrer vi, at alle processer, dokumentation og udført arbejde følger de gældende sikkerhedsregler, så jernbanedriften altid forløber sikkert og pålideligt.",
          button: "Se ECM Certifikat (PDF)"
        }
      }
    },
    specialties: [
      {
        id: "landbrug",
        title: "Landbrugsmaskiner",
        description: "Professionel reparation og service af alle typer landbrugsmaskiner og traktorer.",
        icon: "Tractor"
      },
      {
        id: "entreprenor",
        title: "Entreprenørmaskiner",
        description: "Hurtig service og reparation af entreprenørmateriel, gravemaskiner og læssemaskiner.",
        icon: "Construction"
      },
      {
        id: "havepark",
        title: "Have & Park maskiner",
        description: "Service og vedligeholdelse af maskiner til have, park og grønne områder.",
        icon: "Sprout"
      },
      {
        id: "eftersyn",
        title: "Lovpligtigt eftersyn",
        description: "Certificeret og lovpligtigt eftersyn af lifte, lastbilkraner og gaffeltrucks.",
        icon: "ClipboardCheck"
      },
      {
        id: "hydraulik",
        title: "Hydraulikslanger",
        description: "Hurtig fremstilling og presning af hydraulikslanger på værkstedet eller udekørende.",
        icon: "Droplets"
      },
      {
        id: "smede",
        title: "Smedearbejde",
        description: "Alt i smedearbejde, konstruktioner, svejsning og tilpasninger efter mål.",
        icon: "Hammer"
      },
      {
        id: "ac",
        title: "A/C Service",
        description: "Service, fejlfinding og påfyldning af kølemiddel på klimaanlæg og aircondition.",
        icon: "Snowflake"
      },
      {
        id: "diagnose",
        title: "Diagnoseudlæsning",
        description: "Moderne diagnoseudlæsning og fejlfinding på maskiner og køretøjer.",
        icon: "Cpu"
      }
    ],
    contact: {
      title: "Kontakt os",
      subtitle: "Har du brug for udekørende service?",
      button_call: "Ring nu: 21 59 00 19",
      button_email: "Send mail: kra@vejrumbromaskinforretning.dk",
    }
  },
  en: {
    company: "Vejrumbro Smede Maskinforretning ApS",
    address: "Hovedgaden 4, 8830 Tjele, Denmark",
    phone: "21 59 00 19",
    email: "kra@vejrumbromaskinforretning.dk",
    cvr: "46156765",
    nav: [
      { name: "Home", path: "/" },
      { name: "On-site service", path: "/udekoerende-service" },
      { name: "Metalwork & machinery", path: "/smede-og-maskinforretning" },
      { name: "Crane & lift", path: "/kran-og-lift" },
      { name: "Spare parts", path: "/reservedele" },
      { name: "About us", path: "/om-os" },
      { name: "Contact", path: "/kontakt" },
    ],
    ui: {
      readMore: "Read more",
      callNow: "Call now",
      sendMail: "Send email",
      ourServices: "Our Services",
      servicesSubtitle: "We offer professional solutions in blacksmithing and machine work with a focus on quality and flexibility.",
      focusArea: "Focus Area",
      owner: "Director",
      aboutUs: "About us",
      solidPartner: "A solid partner nationwide",
      aboutText: "We serve private, business, and agricultural customers with everything from small repairs to larger machine services and blacksmithing. Our focus is always on delivering a solution that works in reality.",
      quality: "Quality",
      personal: "Personal",
      flexible: "Flexible",
      local: "Nationwide",
      findUs: "Find us here",
      addressLabel: "Address",
      phoneLabel: "Phone",
      contactMessage: "We look forward to hearing from you.",
      sendMessage: "Send a message",
      nameLabel: "Name",
      namePlaceholder: "Your full name",
      contactLabel: "Email / Phone",
      contactPlaceholder: "How do we contact you?",
      messageLabel: "Message",
      messagePlaceholder: "Describe your task...",
      submitButton: "Send message",
      successMessage: "Thank you for your message!",
      ctaTitle: "How can we help you with your next project?",
      weOffer: "We offer including:",
      needAssistance: "Need assistance?",
      contactToday: "Contact us today for a non-binding chat about your project or task.",
      nationwide: "On-site service nationwide",
      nationwideText: "We are happy to come to you and help with your machine or blacksmithing work, regardless of where you are.",
      copyright: "All rights reserved."
    },
    hero: {
      title: "On-site service for blacksmith and machinery tasks",
      subtitle: "Vejrumbro Smede Maskinforretning ApS helps private customers, businesses, and agriculture with blacksmithing, machine service, crane/lifts, and spare parts — both in the workshop and on-site.",
      cta_call: "Call",
      cta_email: "Write",
    },
    sections: {
      onSite: {
        title: "On-site service",
        description: "Quick help at the customer's location. We serve businesses, agriculture, and private clients.",
        features: [
          "Repair and service of agricultural machinery",
          "Repair and service of construction machinery",
          "Repair and service of garden and park machinery",
          "On-site manufacturing of hydraulic hoses",
          "Mobile A/C Service & diagnostics",
          "Fast and flexible response"
        ],
        image: "/images/mobile_repair_image.png"
      },
      metalwork: {
        title: "Metalwork & machinery",
        description: "Professional blacksmithing and machine service performed with a focus on quality and durable solutions.",
        features: [
          "Professional blacksmith work",
          "Repair and service of agricultural machinery",
          "Repair and service of construction machinery",
          "Repair and service of garden and park machinery",
          "Manufacturing of hydraulic hoses",
          "A/C Service & diagnostics"
        ],
        image: "/images/shutterstock_1661945515.jpg"
      },
      crane: {
        title: "Crane & lift",
        description: "Service and maintenance of cranes and lifts. We ensure your equipment is safe and ready for operation.",
        features: [
          "Mandatory inspection of lifts",
          "Mandatory inspection of truck cranes",
          "Mandatory inspection of forklifts",
          "Service and maintenance of cranes and lifts",
          "Troubleshooting and repair"
        ],
        image: "/images/crane-equipment-only.jpg"
      },
      parts: {
        title: "Spare parts",
        description: "We source the right parts for your machines and technical solutions.",
        features: [
          "Sale of spare parts",
          "Assistance in finding the right part",
          "Parts for machines and equipment",
          "Fast delivery/pickup"
        ],
        image: "/images/spare-parts.jpg"
      },
      about: {
        title: "Nationwide and personal service",
        description: "Vejrumbro Smede Maskinforretning ApS is your nationwide partner.",
        content: "We are a practical and solution-oriented company that values personal contact. With years of experience and a flexible approach, we always find a solution that lasts.",
        image: "/images/kundes img/Karsten-258x300.jpg",
        certificate: {
          title: "ECM Certification – Rail & Maskinteknik ApS",
          text1: "Rail & Maskinteknik ApS is certified as an Entity in Charge of Maintenance (ECM) in accordance with EU Regulation 2019/779. This certificate is your guarantee that we comply with the strictest European standards and safety requirements for the maintenance of railway vehicles and associated equipment.",
          text2: "As a trusted partner, we ensure that all processes, documentation, and work performed follow the applicable safety regulations, so that railway operations always run safely and reliably.",
          button: "View ECM Certificate (PDF)"
        }
      }
    },
    specialties: [
      {
        id: "landbrug",
        title: "Agricultural Machinery",
        description: "Professional repair and service of all types of agricultural machinery and tractors.",
        icon: "Tractor"
      },
      {
        id: "entreprenor",
        title: "Construction Machinery",
        description: "Fast service and repair of construction equipment, excavators, and loaders.",
        icon: "Construction"
      },
      {
        id: "havepark",
        title: "Garden & Park Machinery",
        description: "Service and maintenance of machinery for gardens, parks, and green areas.",
        icon: "Sprout"
      },
      {
        id: "eftersyn",
        title: "Mandatory Inspections",
        description: "Certified and statutory inspection of lifts, truck cranes, and forklifts.",
        icon: "ClipboardCheck"
      },
      {
        id: "hydraulik",
        title: "Hydraulic Hoses",
        description: "Fast manufacturing and pressing of hydraulic hoses in the workshop or on-site.",
        icon: "Droplets"
      },
      {
        id: "smede",
        title: "Blacksmithing",
        description: "All types of blacksmithing, metal constructions, welding, and custom adjustments.",
        icon: "Hammer"
      },
      {
        id: "ac",
        title: "A/C Service",
        description: "Service, troubleshooting, and refrigerant refilling on climate systems and air conditioning.",
        icon: "Snowflake"
      },
      {
        id: "diagnose",
        title: "Diagnostics",
        description: "Modern diagnostic reading and troubleshooting on machines and vehicles.",
        icon: "Cpu"
      }
    ],
    contact: {
      title: "Contact us",
      subtitle: "Do you need on-site service?",
      button_call: "Call now: 21 59 00 19",
      button_email: "Send email: kra@vejrumbromaskinforretning.dk",
    }
  }
};
